/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import ReactDOM from 'react-dom';

import TemplateUtil from 'notebook/entry-templates/TemplateUtil';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Modal from 'ui-library/modals/Modal';

interface Props {
  initialDate: string;
  setDate: (...args: Array<any>) => any;
  onRequestClose: (...args: Array<any>) => any;
}

type State = any;

class DaySelectorModal extends React.Component<Props, State> {
  state: State = {
    dayNumber: TemplateUtil.isoDateToTemplateDay(this.props.initialDate),
  };

  dayNumberRef = React.createRef<HTMLInputElement>();

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setDateAndClose = () => {
    const isoDate = TemplateUtil.templateDayToIsoDate(this.state.dayNumber);
    this.props.setDate(isoDate);
    this.props.onRequestClose();
  };

  componentDidMount(): void {
    (ReactDOM.findDOMNode(this.dayNumberRef.current) as HTMLInputElement).select();
  }

  render(): JSX.Element {
    return (
      <Modal
        title="Edit day number"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.setDateAndClose}
        buttons={[
          {text: 'Set day', submit: true, disabled: 1 > this.state.dayNumber || this.state.dayNumber > 1000},
        ]}
        small={true}
      >
        <FormGroup>
          <Label>Day</Label>
          <input
            min={1}
            max={1000}
            ref={this.dayNumberRef}
            type="number"
            value={this.state.dayNumber}
            onChange={(e) => {
              this.setState({dayNumber: e.target.value});
            }}
          />
        </FormGroup>
      </Modal>
    );
  }
}

export default DaySelectorModal;
